var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-select',{attrs:{"value":_vm.data,"confirm":_vm.confirm,"multiple":_vm.multiple,"clearable":_vm.clearable},on:{"change":_vm.onChange}},[_c('div',{class:_vm.cls,staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }